"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCarsFilter = void 0;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var selectors_1 = require("../redux/selectors");
var sortCarsSlice_1 = require("../redux/slice/sortCarsSlice");
var carsSlice_1 = require("../redux/slice/carsSlice");
var useCarsFilter = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var searchParams = (0, react_router_dom_1.useSearchParams)()[0];
    var _a = (0, react_redux_1.useSelector)(selectors_1.carsSelector), carsList = _a.carsList, isLoading = _a.isLoading, error = _a.error, pagination = _a.pagination;
    var viewMode = (0, react_redux_1.useSelector)(sortCarsSlice_1.selectViewMode);
    var sortOption = (0, react_redux_1.useSelector)(sortCarsSlice_1.selectSortOption);
    var currentPage = Number(searchParams.get('page')) || 1;
    var handlers = react_1.default.useMemo(function () { return ({
        handleScrollTop: function () {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        },
    }); }, []);
    react_1.default.useEffect(function () {
        var params = new URLSearchParams(searchParams);
        Object.values(sortCarsSlice_1.SORT_OPTIONS).forEach(function (option) {
            params.delete(option.param);
        });
        if (sortOption) {
            params.set(sortCarsSlice_1.SORT_OPTIONS[sortOption].param, 'true');
        }
        navigate("?".concat(params.toString()), { replace: true });
        var requestParams = {};
        params.forEach(function (value, key) {
            if (value)
                requestParams[key] = value;
        });
        dispatch((0, carsSlice_1.loadCars)(__assign(__assign({}, requestParams), { page: currentPage })));
        if (currentPage > 1) {
            handlers.handleScrollTop();
        }
    }, [dispatch, searchParams, currentPage, sortOption, handlers, navigate]);
    return {
        viewMode: viewMode,
        isLoading: isLoading,
        error: error,
        sortedCars: carsList,
        pagination: pagination,
        handlers: handlers,
    };
};
exports.useCarsFilter = useCarsFilter;
